import type { RouteObject, LoaderFunction } from 'react-router-dom';

type CustomRouteObject = {
  help?: {
    /** 系统操作指南 */
    systemGuide: string,
    /** 常见问题 */
    commonProblem: string,
  };
  /** 隐藏 ContentHead */
  hideContentHead?: Boolean,
  /** 隐藏 ContentFooter */
  hideContentFooter?: Boolean,
  component?: LoaderFunction;
  name?: string;
  children?: CustomRouteObject[];
} & RouteObject;

export default [
  {
    path: '/',
    name: '轨迹查询',
    component: () => import('@/pages/Track/index'),
  },
  {
    path: '/Track/info',
    name: '轨迹详情',
    component: () => import('@/pages/Track/info'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('@/pages/Track/PrivacyPolicy'),
  },
  {
    path: '/terms-of-use',
    name: 'Terms of Use',
    component: () => import('@/pages/Track/TermsOfUse'),
  },
] as CustomRouteObject[];
